/// <reference path="index.d.ts" />

import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import registerServiceWorker from './registerServiceWorker'

import './index.css'


ReactDOM.render(
  <App/>,
  document.getElementById('root') as HTMLElement
)


registerServiceWorker()


// Module augmentation (see index.d.ts)

declare module 'React' {
  interface Component<P, S> {
    setState<K extends keyof T, T = this['state']>(
        state: ((prevState: Readonly<T>, props: Readonly<P>) => (Pick<T, K> | T | null)) | (Pick<T, K> | T | null),
        callback?: () => void
    ): void
  }
}



// WEBPACK FOOTER //
// ./src/index.tsx